export const TIME_SYSTEM = "UTC";
export const REFERENCE_FRAME = "GCRF";

export const withTimeSystem = (label: string) => `${label} (${TIME_SYSTEM})`;
export const referenceFrameLabel = `Reference frame: ${REFERENCE_FRAME}`;
